import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './ConversationErrorAlert.module.scss'

const ConversationErrorAlert = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation(['Clients', 'Common'])

  return (
    <KibTopLevelAlert
      actions={
        <KibButtonNew
          emphasis="primary"
          size="small"
          theme="utility"
          onClick={onClick}
        >
          {t('Common:TRY_AGAIN')}
        </KibButtonNew>
      }
      className={styles.errorAlert}
      heading={t('Clients:COMMUNICATION_WIDGET.COMMUNICATIONS_FAILED_TO_LOAD')}
      severity="warning"
    />
  )
}

export default ConversationErrorAlert
